import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { FaList, FaPlus, FaRecordVinyl, FaEdit, FaFilter } from 'react-icons/fa';
import { MdDelete, MdEdit, MdNotificationsActive } from 'react-icons/md';
import { deleteLead, notifyToSalesLead } from 'redux/crm/leadSlice';
import { Button, DetailPageShell } from 'components/common';
import ConfirmationModal from 'components/common/Confirmation';
import LeadRecordConfirm from './confirmation/LeadRecordConfirm';

const LeadDetailHeader = ({ lead }) => {
  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [messageConfirm, setMessageConfirm] = useState(null);
  const [showRecordConfirm, setShowRecordConfirm] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    allow_edit,
    allow_delete,
    allow_record,
    allow_send_notify
  } = lead?.permissions || {};

  const leadUrl = '/crm/leads';
  const leadId = lead?.id;

  const handleEditLead = () => {
    navigate(`${leadUrl}/${leadId}/edit`, { state: { lead } });
  };

  const handleActionConfirm = async () => {
    try {
      dispatch(deleteLead(leadId));
      navigate(`${leadUrl}/list`);
      setShowConfirmationDelete(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleDeleteLead = () => {
    const message = `Are you sure to delete Lead ID#<strong class='tw-text-red-600'>${leadId}</strong>?`;
    setMessageConfirm(<span dangerouslySetInnerHTML={{ __html: message }} />);
    setShowConfirmationDelete(true);
  };

  const menuItems = [
    ...(allow_record ? [
      { label: 'Record', icon: <FaRecordVinyl size={13} className="tw-text-yellow-500" />, onClick: () => setShowRecordConfirm(true) }
    ] : []),
    ...(allow_send_notify ? [
      { label: 'Send notify to Sales', icon: <MdNotificationsActive size={14} className="tw-text-yellow-500" />, onClick: () => dispatch(notifyToSalesLead(leadId)) }
    ] : []),
    ...(allow_edit ? [
      { divider: true },
      { label: 'Edit', icon: <MdEdit size={14} />, onClick: handleEditLead }
    ] : []),
    ...(allow_delete ? [
      { divider: true },
      { label: 'Delete', icon: <MdDelete size={14} />, danger: true, onClick: handleDeleteLead }
    ] : []),
  ];

  return (
    <>
      <DetailPageShell
        title={lead?.name || `Lead #${leadId ?? ''}`}
        icon={FaFilter}
        onBack={() => navigate(-1)}
        menuItems={menuItems}
        menuWidth={220}
        actions={
          <>
            <Button
              variant="secondary"
              size="sm"
              leftIcon={FaPlus}
              className="tw-hidden sm:tw-inline-flex"
              onClick={() => navigate(`${leadUrl}/new`)}
            >
              <span className="tw-hidden xl:tw-inline">New Lead</span>
            </Button>
            {allow_edit && (
              <Button
                variant="secondary"
                size="sm"
                leftIcon={FaEdit}
                className="tw-hidden sm:tw-inline-flex"
                onClick={handleEditLead}
              >
                <span className="tw-hidden xl:tw-inline">Edit Lead</span>
              </Button>
            )}
            <Button
              variant="secondary"
              size="sm"
              leftIcon={FaList}
              className="tw-hidden sm:tw-inline-flex"
              onClick={() => navigate(`${leadUrl}/list`)}
            >
              <span className="tw-hidden xl:tw-inline">List</span>
            </Button>
          </>
        }
      />

      {showConfirmationDelete && (
        <ConfirmationModal
          show={showConfirmationDelete}
          onHide={() => setShowConfirmationDelete(false)}
          onConfirm={handleActionConfirm}
          message={messageConfirm}
        />
      )}

      {showRecordConfirm && (
        <LeadRecordConfirm
          showModal={showRecordConfirm}
          setshowModal={setShowRecordConfirm}
          lead={lead}
        />
      )}
    </>
  );
};

LeadDetailHeader.propTypes = {
  lead: PropTypes.object
};

export default LeadDetailHeader;
